import * as toUnicodeVariant from "./toUnicodeVariant.js"
export const string_to_unicode_variant = toUnicodeVariant.default
